import { Captcha } from '@packages/captcha/src';
import { Dialog } from '@packages/shared';
import type { CaptchaData } from '@packages/captcha';

export const CaptchaDialog = ({
  captchaData,
  captchaSuccess,
}: {
  captchaData: CaptchaData;
  captchaSuccess: () => void;
}) => (
  <Dialog
    open
    title="Sicherheitsprüfung"
    dialogContent={<Captcha captchaData={captchaData} onSuccess={captchaSuccess} />}
  />
);
